import React, { useState, useEffect } from "react";
import {
    Modal,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../common/customInput";
import ImagesInput from "../common/ImageInput"
import axios from "axios";
import customAxios from "../../customAxios";
import { toast } from "react-toastify";
import { addBrand,getBrandData, updateBrand } from "../../redux/actions/brandActions";
import { API_URL } from "../../config/constant";

const AddBrand = ({ openModal, onCloseModal, brandData }) => {
  const dispatch = useDispatch();
  const isEdit = Boolean(brandData?._id);

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const schema = yup.object({
    brandName: yup.string().max(40).required("Brand name is required"),
    status: yup.string().required("Status is required"),
    logo: yup.mixed().test(
      "logoRequired",
      "Logo is required",
      (file) => {
        if (isEdit) return true;   // logo optional in edit
        return file ? true : false;
      }
    )
  });

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
  });

  // 🔥 PREFILL DATA FOR EDIT
  useEffect(() => {
    if (brandData) {
      setValue("brandName", brandData.brandName);
      setValue("status", brandData.status || "active");
    }
  }, [brandData, setValue]);

  const onSubmit = async (data) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("brandName", data.brandName);
    formData.append("status", data.status);

    if (image) {
      formData.append("logo", image);
    }

    if (isEdit) {
      await dispatch(updateBrand(brandData._id, formData));
    } else {
      await dispatch(addBrand(formData));
    }

    await dispatch(getBrandData());
    clearClose();
    setLoading(false);
  };

  const clearClose = () => {
    reset({ brandName: "", status: "active", logo: "" });
    setImage(null);
    onCloseModal();
  };

  return (
    <Modal isOpen={openModal} toggle={clearClose}>
      <ModalHeader toggle={clearClose}>
        {isEdit ? "Edit Brand" : "Add Brand"}
      </ModalHeader>

      <ModalBody>
        <Form>
          <CustomInput
            fieldLabel="Brand Name"
            control={control}
            error={errors.brandName}
            fieldName="brandName"
          />

          <FormGroup>
            <Label for="status">Status</Label>
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  type="select"
                  id="status"
                  invalid={!!errors.status}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Input>
              )}
            />
            {errors.status && <div className="invalid-feedback">{errors.status.message}</div>}
          </FormGroup>

          <ImagesInput
            fieldLabel="Logo (256 × 256)"
            control={control}
            error={errors.logo}
            fieldName="logo"
            type="file"
            onChangeValue={(file) => setImage(file)}
          />

          {/* Existing logo preview */}
          {isEdit && !image && (
            <img
              src={`${API_URL}${brandData.logoUrl}`}
              alt="logo"
              width={100}
              style={{ marginTop: 10 }}
            />
          )}

          {/* New logo preview */}
          {image && (
            <img
              src={URL.createObjectURL(image)}
              width={100}
              style={{ marginTop: 10 }}
            />
          )}
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
        >
          {loading ? "Saving..." : isEdit ? "Update" : "Save"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default AddBrand;
